import * as ApiActions from '../../constants/ApiActions';
import * as UseCaseActions from '../../constants/UseCases';

import { autoLogin } from './autoLogin';
import { changeInteractiveRadioMode } from './changeInteractiveRadioMode';
import { closeSearch } from './closeSearch';
import { generateDeepLink } from './generateDeepLink';
import { handlePremiumAccess } from './handlePremiumAccess';
import * as UseCaseHandlers from './handlers';
import { initiatePremiumAccess } from './initiatePremiumAccess';
import { login } from './login';
import { openErrorToast } from './openErrorToast';
import { openSearch } from './openSearch';
import { playResumeSource } from './playResumeSource';
import { playRewardsAd } from './playRewardsAd';
import { closeRewardsCoachmark } from './playRewardsAd/helpers';
import { replayTrack } from './replayTrack';
import { resetPasswordAndReauth } from './resetPasswordAndReauth';
import { scrubTrack } from './scrubTrack';
import { setSourceRepeatMode } from './setSourceRepeatMode';
import { setSourceShuffleMode } from './setSourceShuffleMode';
import { signOut } from './signOut';
import { signUp } from './signUp';
import { skipAudioAd } from './skipAudioAd';
import { skipTrackBack } from './skipTrackBack';
import { skipTrackForward } from './skipTrackForward';
import { startStation } from './startStation';
import { trackFeedback } from './trackFeedback';
import { upgrade } from './upgrade';

export default [
  {
    actionType: UseCaseActions.ActionTypes.LOGIN_LISTENER,
    concur: 'takeOnly',
    handler: login,
  },
  {
    actionType: UseCaseActions.ActionTypes.AUTO_LOGIN,
    concur: 'takeOnce',
    handler: autoLogin,
  },
  {
    actionType: UseCaseActions.ActionTypes.RESET_PASSWORD_AND_REAUTH,
    concur: 'takeOnly',
    handler: resetPasswordAndReauth,
  },
  {
    actionType: UseCaseActions.ActionTypes.PAUSE_TRACK,
    concur: 'takeLatest',
    handler: UseCaseHandlers.pauseTrack,
  },
  {
    actionType: UseCaseActions.ActionTypes.SKIP_TRACK_BACK,
    concur: 'takeOnly',
    handler: skipTrackBack,
  },
  {
    actionType: UseCaseActions.ActionTypes.SKIP_TRACK_FORWARD,
    concur: 'takeLatest',
    handler: skipTrackForward,
  },
  {
    // This handles audio ad skips when station APS is disabled.
    actionType: UseCaseActions.ActionTypes.SKIP_AUDIO_AD,
    concur: 'takeOnly',
    handler: skipAudioAd,
  },
  {
    actionType: UseCaseActions.ActionTypes.REPLAY_TRACK,
    concur: 'takeLatest',
    handler: replayTrack,
  },
  {
    actionType: UseCaseActions.ActionTypes.SCRUB_TRACK,
    concur: 'takeOnly',
    handler: scrubTrack,
  },
  {
    actionType: UseCaseActions.ActionTypes.SET_SOURCE_REPEAT_MODE,
    concur: 'takeLatest',
    handler: setSourceRepeatMode,
  },
  {
    actionType: UseCaseActions.ActionTypes.SET_SOURCE_SHUFFLE_MODE,
    concur: 'takeLatest',
    handler: setSourceShuffleMode,
  },
  {
    actionType: UseCaseActions.ActionTypes.ADD_REPLAY_TRACK_TO_PLAYLIST,
    concur: 'takeLatest',
    handler: UseCaseHandlers.addReplayTrackToPlaylist,
  },
  {
    actionType: UseCaseActions.ActionTypes.PROMPT_STREAM_VIOLATION,
    concur: 'takeLatest',
    handler: UseCaseHandlers.promptStreamViolation,
  },
  {
    actionType: UseCaseActions.ActionTypes.START_STATION,
    concur: 'takeOnly',
    handler: startStation,
  },
  {
    actionType: UseCaseActions.ActionTypes.HANDLE_PREMIUM_ACCESS,
    concur: 'takeOnly',
    handler: handlePremiumAccess,
  },
  {
    actionType: UseCaseActions.ActionTypes.INITIATE_PREMIUM_ACCESS,
    concur: 'takeOnly',
    handler: initiatePremiumAccess,
  },
  {
    actionType: UseCaseActions.ActionTypes.PLAY_RESUME_SOURCE,
    concur: 'takeLatest',
    handler: playResumeSource,
  },
  {
    actionType: UseCaseActions.ActionTypes.PLAY_REWARDS_AD,
    concur: 'takeEvery',
    handler: playRewardsAd,
  },
  {
    actionType: UseCaseActions.ActionTypes.CHANGE_INTERACTIVE_RADIO_MODE,
    concur: 'takeLatest',
    handler: changeInteractiveRadioMode,
  },
  // Close the Rewards Coachmark if login fails. We want to try and prevent the anonymous listeners from enabling PA.
  {
    actionType: ApiActions.ApiActions.LOGIN_FAIL,
    concur: 'takeEvery',
    handler: closeRewardsCoachmark,
  },
  {
    actionType: UseCaseActions.ActionTypes.NAVIGATE_TO_COMMUNITY,
    concur: 'takeLatest',
    handler: UseCaseHandlers.navigateToCommunity,
  },
  {
    actionType: UseCaseActions.ActionTypes.SIGN_UP,
    concur: 'takeLatest',
    handler: signUp,
  },
  {
    actionType: UseCaseActions.ActionTypes.SIGN_OUT,
    concur: 'takeLatest',
    handler: signOut,
  },
  {
    actionType: UseCaseActions.ActionTypes.OPEN_SEARCH,
    concur: 'takeEvery',
    handler: openSearch,
  },
  {
    actionType: UseCaseActions.ActionTypes.CLOSE_SEARCH,
    concur: 'takeEvery',
    handler: closeSearch,
  },
  {
    actionType: UseCaseActions.ActionTypes.UPGRADE,
    concur: 'takeLatest',
    handler: upgrade,
  },
  {
    actionType: UseCaseActions.ActionTypes.OPEN_ERROR_TOAST,
    concur: 'takeLatest',
    handler: openErrorToast,
  },
  {
    actionType: UseCaseActions.ActionTypes.ADD_TRACK_FEEDBACK,
    concur: 'takeLatest',
    handler: trackFeedback,
  },
  {
    actionType: UseCaseActions.ActionTypes.REMOVE_TRACK_FEEDBACK,
    concur: 'takeLatest',
    handler: trackFeedback,
  },
  {
    actionType: UseCaseActions.ActionTypes.GENERATE_DEEP_LINK,
    concur: 'takeLatest',
    handler: generateDeepLink,
  },
];
